<template>
  <div class="row justify-content-md-center">
    <div class="col-sm-12 col-md-6 col-lg-4">
      <div class="card">
        <img src="../assets/logoLCT.gif" class="card-img-top"/>
        <div class="card-body">
          <h5 class="card-title">
            <font-awesome-icon icon="user" />
            Choisissez un nom d'utilisateur
          </h5>
          <form>
            <div class="form-group">
              <label for="usernameField">
                Votre nom dans le jeu de Scrabble Lettre Compte Triple:</label>
              <input type="text" class="form-control"
              id="usernameField"
              aria-describedby="usernameHelp"
              v-model="username">
              <small id="usernameHelp" class="form-text text-muted">
                Les termes injurieux sont à proscrire !<br />
                Vous pourrez changer de nom ultérieurement.
              </small>
            </div>
            <div class="row justify-content-md-center">
              <button type="button"
              class="btn btn-primary"
              @click="updateUserName(username)"
              :disabled="!username">Valider</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iam from '../iam';

export default {
  name: 'SetUserNameModal',
  data() {
    return {
      username: iam.getConnectedUser() ? iam.getConnectedUser().username : '',
    };
  },
  methods: {
    updateUserName(username) {
      if (username !== '') {
        this.$http.post(`${process.env.LCT_API_URL}/users`, {
          username,
          picture: iam.getConnectedUser() ? iam.getConnectedUser().picture : undefined,
        }).then((response) => {
          iam.setConnectedUser(response.data);
          this.$router.push('Lobby');
        });
      }
    },
  },
};
</script>

<style scoped>
img{
  max-width: 320px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/SetUserNameModale.vue